module.exports = __webpack_public_path__ + "img/cbry1.9d08cc97.gif";